import { SampleSerieType, SampleCollectionLocation } from './samples.types';

export enum ReceivedSampleSerieStatus {
  RECEIVED = 'RECEIVED',
  IN_SEQUENCING = 'IN_SEQUENCING',
  SEQUENCING_COMPLETE = 'SEQUENCING_COMPLETE',
  RESULTS_DELIVERED = 'RESULTS_DELIVERED',
}

export interface ReceivedSamplesSeries {
  collectionLocation: SampleCollectionLocation;
  status: ReceivedSampleSerieStatus;
  groupValue: string;
  type: SampleSerieType;
  value: number;
}

export interface ReceivedDataPercentChanges {
  collectionLocation: SampleCollectionLocation;
  value: number | null;
}

export interface ReceivedDataStats {
  percentChanges: ReceivedDataPercentChanges[];
}

export interface ReceivedSamples {
  series: ReceivedSamplesSeries[];
  stats: ReceivedDataStats;
}
